import { ConnectionTypeDialog } from './ConnectionTypeDialog';
import { DeviceHealthCheck } from './DeviceHealthCheck';
import { DeviceHealthSuccess } from './DeviceHealthSuccess';
import { ConnectionErrorDialog } from './ConnectionErrorDialog';

/**
 * Connection Wizard - Main container
 * 
 * Manages the device connection flow:
 * 1. Connection type selection (Cable/USB or Bluetooth/BLE)
 * 2. Native device picker (WebUSB or Web Bluetooth, browser native)
 * 3. Device health check
 * 4. Success state with "Start test" button
 * 5. Error handling with troubleshooting tips
 */
export const ConnectionWizard = () => {
  return (
    <>
      <ConnectionTypeDialog />
      <DeviceHealthCheck />
      <DeviceHealthSuccess />
      <ConnectionErrorDialog />
    </>
  );
};
